/**
 * Tracks which SHARED playlists the viewer has already acknowledged editing
 * during this page session — spec item E ("FIRST edit per playlist PER PAGE
 * SESSION opens a confirm dialog"). A plain module-level Set, matching the
 * prototype's own in-memory `p.ack` flag (.claude/pp-campaign-builder-
 * prototype.html's guardShared()): it lives only as long as this JS module
 * stays loaded, so it resets on a full page reload — intentionally NOT
 * localStorage/sessionStorage, which would survive a reload and over-trust
 * a stale acknowledgement.
 */
const ackedPlaylistIds = new Set();

export function hasAckedSharedPlaylistEdit(playlistId) {
  return ackedPlaylistIds.has(playlistId);
}

export function ackSharedPlaylistEdit(playlistId) {
  ackedPlaylistIds.add(playlistId);
}
